// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.POnsfjJlhwTcIk6FybbT {
  display: flex;
  align-items: center;
  line-height: 23px;
  color: #FFF;
  font-size: 19px;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}
.POnsfjJlhwTcIk6FybbT[data-finished='true'] {
  color: #D9D9D9;
}
.om7gYSqXOlBhJTFykjJS {
  width: 23px;
  height: 23px;
  margin-right: 8px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .POnsfjJlhwTcIk6FybbT {
    line-height: 16px;
    font-size: 13px;
  }
  .om7gYSqXOlBhJTFykjJS {
    width: 17px;
    height: 16px;
    margin-right: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PeriodDisplay/PeriodDisplay.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".periodDisplay {\n  display: flex;\n  align-items: center;\n  line-height: 23px;\n  color: #FFF;\n  font-size: 19px;\n  font-weight: 700;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.periodDisplay[data-finished='true'] {\n  color: #D9D9D9;\n}\n.periodIcon {\n  width: 23px;\n  height: 23px;\n  margin-right: 8px;\n}\n@media (--campaign-mobile) {\n  .periodDisplay {\n    line-height: 16px;\n    font-size: 13px;\n  }\n  .periodIcon {\n    width: 17px;\n    height: 16px;\n    margin-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"periodDisplay": `POnsfjJlhwTcIk6FybbT`,
	"periodIcon": `om7gYSqXOlBhJTFykjJS`
};
export default ___CSS_LOADER_EXPORT___;
